export default "__VITE_ASSET__BjjP3F1p__"